import { Box, Icon, Table, Text } from '@factorialco/deprecated-design-system'

import createMemo from 'modules/core/hooks/createMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import { questionGroupRespondent } from 'modules/core/store/collections/users'

import EmployeeLabelWithFallback from 'modules/surveys/components/Participants/common/EmployeeLabelWithFallback'
import Location from 'modules/surveys/components/Participants/common/Location'
import { SURVEY_MINIMUM_ANSWERS_TO_SHOW_ANONYMOUS } from 'modules/surveys/lib/constants'
import type SurveyForm from 'modules/surveys/store/models/Form'
import type QuestionGroup from 'modules/surveys/store/models/QuestionGroup'
import type Survey from 'modules/surveys/store/models/v2/Survey'

import type { Employees } from 'modules/employees/store/collections/employees'

const useFilter = createMemo(
  (questionGroups: QuestionGroup[], form: SurveyForm | Survey, search: string) =>
    questionGroups.filter((questionGroup) => {
      if (form.isAnonymous) return true

      return questionGroupRespondent(questionGroup)?.matchesFullName(search)
    })
)

interface Props {
  form: SurveyForm | Survey
  questionGroups: QuestionGroup[]
  search: string
  employees: Employees
}

export default function ResponsesBody({ form, search, questionGroups, employees }: Props) {
  const { navigation } = useNavigation()
  const filteredQuestionGroups = useFilter(questionGroups, form, search)
  const isCurrentUserIncluded = questionGroups.some((questionGroup) =>
    questionGroupRespondent(questionGroup)
  )
  const hasMoreThanMinimumRespondents = isCurrentUserIncluded
    ? questionGroups.length > SURVEY_MINIMUM_ANSWERS_TO_SHOW_ANONYMOUS
    : questionGroups.length >= SURVEY_MINIMUM_ANSWERS_TO_SHOW_ANONYMOUS
  return (
    <Table.Body>
      {filteredQuestionGroups.map((questionGroup) => {
        const user = questionGroupRespondent(questionGroup)
        const { id, answered_at } = questionGroup.attributes
        const canSeeResponseShowPage = !form.isAnonymous || hasMoreThanMinimumRespondents || !!user
        const route = canSeeResponseShowPage
          ? navigation.engagement.surveys.id.responses.questionGroupId.fullPath({
              id: form.attributes.id,
              question_group_id: id,
            })
          : ''

        return (
          <Table.Row.Router key={id} to={route}>
            <Table.Cell colSpan={2}>
              <EmployeeLabelWithFallback user={user} isAnonymous={form.isAnonymous} />
            </Table.Cell>
            <Table.Cell>{form.isAnonymous || !user ? '-' : <Location user={user} employees={employees} />}</Table.Cell>
            <Table.Cell>
              <Text.Normal>{dateBackendDateTimeToUI(answered_at)}</Text.Normal>
            </Table.Cell>
            <Table.Cell>
              {canSeeResponseShowPage && (
                <Box alignItems="flexEnd">
                  <Icon.Medium icon="arrow-right" />
                </Box>
              )}
            </Table.Cell>
          </Table.Row.Router>
        )
      })}
    </Table.Body>
  )
}
